; function CommentsLSToggleVisible() {
    const DOMDisplay = CommentsLsDOMDisplay();

    return {
        fields(valueMessageField, toggleFields) {
            toggleFields.forEach((field) => {
                if (valueMessageField === "") {
                    DOMDisplay.fieldHide(field);
                } else {
                    DOMDisplay.fieldShow(field);
                }
            });
        }
    }
}
